import { createFromIconfontCN } from "@ant-design/icons";

const env =
  process.env.NEXT_PUBLIC_DEPLOY_ENV_LOCAL ||
  process.env.NEXT_PUBLIC_DEPLOY_ENV ||
  "prod";
const uuid = process.env.uuid || "";

// public的所有文件都会上传至OSS的： https://cdn.huaban.com/_next/public/${env} 下, 看 cdn.js 文件逻辑
const iconfontUrl =
  env === "local"
    ? "/_assets/iconfont/iconfont.js"
    : `https://cdn.huaban.com/_next/public/${env}/_assets/iconfont/iconfont.js?${uuid}`;

export default createFromIconfontCN({
  scriptUrl: iconfontUrl,
});
